/**
 * Design System - Core Utilities
 * Système inspiré Shadcn/UI avec couleurs sémantiques
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Utility function pour combiner les classes avec priorité Tailwind
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
